<template>
    <div class="features-info-tab" v-if="group">
        <!-- Toolbar -->
        <feature-toolbar
            class="overview-toolbar"
            v-if="group.count > 0 && isSelectable"
            :exportData="exportData"
            :featureData="featureData"
            :group="group"
            @showFilter="$_onShowFilter($event)"
        />
        <!-- In case of message: no results, none visible or too many results -->
        <div
            v-show="message"
            class="overview-message p-2"
            v-bind:class="{
                'has-results': group.count > 0
            }"
        >
            {{ message }}
        </div>
        <!-- Table -->
        <div class="features-info-tab-content-wrapper">
            <div class="features-info-tab-content">
                <feature-info-table
                    v-if="group.count > 0"
                    :group="group"
                    :selectable="isSelectable"
                    :selectedObject="selectedObject"
                    :showFilter="showFilter"
                    @setExport="$_onSetExport($event)"
                    @setSelectedFeatures="$_onSetSelectedFeatures($event)"
                    @sortObjects="$emit('sortObjects', $event)"
                    @openObject="$emit('openObject', $event)"
                    @openBrkDetails="$emit('openBrkDetails', $event)"
                    @openStufDetails="$emit('openStufDetails', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { isInRange } from '../../../../services/map';

    import FeatureInfoTable from './FeatureInfoTable.vue';
    import LayerFeaturesToolbar from '../toolbars/LayerFeaturesToolbar.vue';
    import { MAX_RESULTS_RELATION } from '../../../../constants';

    export default {
        components: {
            'feature-info-table': FeatureInfoTable,
            'feature-toolbar': LayerFeaturesToolbar
        },
        props: {
            group: { type: Object, required: false },
            selectedObject: { type: Object, required: false }
        },
        data() {
            return {
                exportData: null,
                featureData: null,
                showFilter: false
            };
        },
        computed: {
            ...mapState(['userData', 'defaultMap']),
            ...mapGetters(['getActivatedWFSLayers', 'isMobile']),
            message: function () {
                const maxFeatures = this.userData.maxFeatures;
                const mapViewPort = this.defaultMap.viewport;
                const currentResolution = mapViewPort.resolution;
                const { features, layer } = this.group;
                const inRange = isInRange(
                    currentResolution,
                    layer.minResolution,
                    layer.maxResolution
                );
                let message = '';
                // Check which message should be displayed
                if (features.length === MAX_RESULTS_RELATION) {
                    message = this.$t('relations.maxResultsExceeded', [
                        MAX_RESULTS_RELATION
                    ]);
                } else if (features.length <= maxFeatures && !inRange) {
                    message =
                        'Op deze schaal kunnen de resultaten niet getoond worden in de kaart. Klik op een resultaat in de tabel om in te zoomen.';
                }
                return message;
            },
            isSelectable() {
                return (
                    this.group.selectable ||
                    !!(this.isMobile && this.getActivatedWFSLayers)
                );
            }
        },
        methods: {
            $_onSetExport(data) {
                this.exportData = data;
            },
            $_onSetSelectedFeatures(data) {
                this.featureData = data;
            },
            $_onShowFilter(show) {
                this.showFilter = show;
            }
        }
    };
</script>

<style lang="scss" scoped>
.features-info-tab {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.features-info-tab-content-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
}
.features-info-tab-content {
    position: absolute;
    height: 100%;
    width: 100%;
}
</style>
